<template>
  <WelcomeHeader />

  <!-- Hero -->
  <div class="guide-hero">
    <div class="guide-hero-noise"></div>
    <div class="container guide-hero-inner">
      <span class="guide-badge">ফ্রি রিসোর্স</span>
      <h1 class="guide-hero-title">বিসিএস বিষয়ভিত্তিক গাইডলাইন</h1>
      <p class="guide-hero-sub">বিসিএস ৩৫–৫০ পর্যন্ত টপিকভিত্তিক প্রশ্ন বিশ্লেষণ, হিটম্যাপ ও প্রস্তুতি কৌশল</p>
      <div class="guide-hero-stats">
        <div class="ghs"><div class="ghs-num">১৬</div><div class="ghs-lbl">বিসিএস বিশ্লেষণ</div></div>
        <div class="ghs-sep"></div>
        <div class="ghs"><div class="ghs-num">{{ toBengali(guidelines.length) }}টি</div><div class="ghs-lbl">বিষয় গাইডলাইন</div></div>
        <div class="ghs-sep"></div>
        <div class="ghs"><div class="ghs-num">৯ লাখ+</div><div class="ghs-lbl">অ্যাপ ডাউনলোড</div></div>
      </div>
    </div>
  </div>

  <!-- Cards -->
  <div class="guide-body">
    <div class="container">
      <div class="guide-grid">
        <div v-for="g in guidelines" :key="g.route"
             class="guide-card" @click="go(g.route)">
          <div class="guide-card-img">
            <img :src="g.image" :alt="g.title" />
            <span class="guide-card-mark">{{ g.marks }}</span>
          </div>
          <div class="guide-card-body">
            <div class="guide-tags">
              <span class="gtag" v-for="t in g.tags" :key="t">{{ t }}</span>
            </div>
            <h3>{{ g.title }}</h3>
            <p>{{ g.desc }}</p>
            <div class="guide-card-footer">
              <span class="guide-link">
                গাইডলাইন দেখুন
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M13.267 4.209a.75.75 0 0 0-1.06 1.06l5.58 5.58H3.75a.75.75 0 0 0 0 1.5h14.037l-5.58 5.58a.75.75 0 1 0 1.06 1.06l6.868-6.867a.75.75 0 0 0 0-1.062l-6.868-6.851z" fill="currentColor"/>
                </svg>
              </span>
              <span class="guide-bcs-tag">বিসিএস ৩৫–৫০</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Coming soon -->
      <div class="coming-soon">
        <h3>আরও গাইডলাইন আসছে...</h3>
        <p>গণিত · সাধারণ বিজ্ঞান · মানসিক দক্ষতা · নৈতিকতা ও সুশাসন</p>
        <a href="https://play.google.com/store/apps/details?id=com.bcsprostuti.tanim.bcsprostuti"
           target="_blank" class="cs-btn">এখনই অ্যাপ ডাউনলোড করুন</a>
      </div>
    </div>
  </div>

  <WelcomeFooter :hide-download="true" />
</template>

<script>
import WelcomeHeader from "@/components/WelcomePages/WelcomeHeader.vue";
import WelcomeFooter from "@/components/WelcomePages/WelcomeFooter.vue";
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { guidelines } from "@/components/WelcomePages/guidelinesData";

export default {
  components: { WelcomeHeader, WelcomeFooter },
  setup() {
    const router = useRouter();

    const go = (routeName) => router.push({ name: routeName });

    const toBengali = (n) => {
      const bn = ['০','১','২','৩','৪','৫','৬','৭','৮','৯'];
      return String(n).split('').map(c => bn[parseInt(c)] ?? c).join('');
    };

    onMounted(() => {
      window.scrollTo(0, 0);
      document.title = 'বিসিএস বিষয়ভিত্তিক গাইডলাইন — বিসিএস প্রস্তুতি';
    });

    return { guidelines, go, toBengali };
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }

/* Hero */
.guide-hero {
  position: relative; overflow: hidden;
  background: linear-gradient(140deg, #191B47 0%, #0d0f2e 60%, #1a0828 100%);
  padding: 64px 0 56px;
}
.guide-hero-noise {
  position: absolute; inset: 0; pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");
}
.guide-hero-inner { position: relative; text-align: center; }
.guide-badge {
  display: inline-block; font-size: 0.72rem; font-weight: 700; letter-spacing: 0.07em;
  text-transform: uppercase; color: #0095FF;
  background: rgba(0,149,255,0.12); border: 1px solid rgba(0,149,255,0.3);
  padding: 4px 14px; border-radius: 999px; margin-bottom: 16px;
}
.guide-hero-title {
  font-family: 'Noto Serif Bengali', serif;
  font-size: clamp(1.8rem, 4vw, 2.8rem); font-weight: 900;
  color: #fff; line-height: 1.3; margin-bottom: 12px;
}
.guide-hero-sub { font-size: 1rem; color: #94a3b8; margin-bottom: 36px; }
.guide-hero-stats {
  display: inline-flex; align-items: center;
  background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.12);
  border-radius: 14px; padding: 14px 20px; gap: 0; flex-wrap: wrap; justify-content: center;
}
.ghs { text-align: center; padding: 0 20px; }
.ghs-num { font-family: 'Noto Serif Bengali', serif; font-size: 1.6rem; font-weight: 800; color: #0095FF; line-height: 1; }
.ghs-lbl { font-size: 0.72rem; color: #94a3b8; margin-top: 4px; }
.ghs-sep { width: 1px; height: 36px; background: rgba(255,255,255,0.15); }

/* Body */
.guide-body { background: #f8fafc; padding: 48px 0 64px; }

/* Grid */
.guide-grid {
  width: 100%;
  display: grid; grid-template-columns: repeat(3, 1fr);
  gap: 24px; margin-bottom: 48px;
}
@media(max-width: 992px) { .guide-grid { grid-template-columns: repeat(2, 1fr); } }
@media(max-width: 560px)  { .guide-grid { grid-template-columns: 1fr; } }

/* Card */
.guide-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 18px; overflow: hidden; cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex; flex-direction: column;
}
.guide-card:hover { transform: translateY(-5px); box-shadow: 0 12px 32px rgba(25,27,71,0.12); border-color: #0095FF; }

.guide-card-img { position: relative; overflow: hidden; }
.guide-card-img img { width: 100%; height: auto; display: block; }
.guide-card-mark {
  position: absolute; top: 12px; right: 12px;
  background: #191B47; color: #0095FF;
  font-size: 0.72rem; font-weight: 800;
  padding: 4px 12px; border-radius: 999px;
}

.guide-card-body { padding: 20px; flex: 1; display: flex; flex-direction: column; }
.guide-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 12px; }
.gtag {
  font-size: 0.68rem; font-weight: 600; color: #4f46e5;
  background: #eef2ff; border: 1px solid #c7d2fe;
  padding: 2px 8px; border-radius: 4px;
}
.guide-card-body h3 { font-size: 1rem; font-weight: 800; color: #191B47; margin: 0 0 8px 0; text-align: left; }
.guide-card-body p { font-size: 0.84rem; color: #64748b; line-height: 1.65; margin: 0 0 16px 0; text-align: left; flex: 1; }
.guide-card-footer { display: flex; align-items: center; justify-content: space-between; margin-top: auto; }
.guide-link {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 0.82rem; font-weight: 700; color: #191B47;
}
.guide-bcs-tag { font-size: 0.7rem; color: #94a3b8; background: #f1f5f9; padding: 3px 8px; border-radius: 4px; }

/* Coming soon */
.coming-soon {
  background: linear-gradient(135deg, #191B47, #312e81);
  border-radius: 18px; padding: 40px; text-align: center; color: #fff;
}
.coming-soon h3 { font-family: 'Noto Serif Bengali', serif; font-size: 1.3rem; font-weight: 800; margin-bottom: 8px; }
.coming-soon p { color: #c7d2fe; font-size: 0.9rem; margin-bottom: 24px; }
.cs-btn {
  display: inline-flex; align-items: center;
  background: #0095FF; color: #fff;
  font-weight: 700; font-size: 0.9rem;
  border-radius: 10px; padding: 12px 28px;
  text-decoration: none; transition: all 0.2s;
}
.cs-btn:hover { background: #007AD6; transform: scale(1.03); }
</style>
